import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { SimplebarAngularModule } from 'simplebar-angular';
import { LanguageService } from '../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';
import { ClickOutsideModule } from 'ng-click-outside';

import { LayoutComponent } from './layout.component';
import { VerticalComponent } from './vertical/vertical.component';
import { TopbarComponent } from './topbar/topbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { FooterComponent } from './footer/footer.component';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { HorizontaltopbarComponent } from './horizontaltopbar/horizontaltopbar.component';
import { AuthlayoutComponent } from './authlayout/authlayout.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from '@shared';
import { BusinesslayoutComponent } from './businesslayout/businesslayout.component';
import { NotificationsPromptComponent } from './notifications-prompt/notifications-prompt.component';

@NgModule({
  declarations: [
    NotificationsPromptComponent,
    LayoutComponent,
    VerticalComponent,
    TopbarComponent,
    SidebarComponent,
    RightsidebarComponent,
    FooterComponent,
    HorizontalComponent,
    HorizontaltopbarComponent,
    AuthlayoutComponent,
    BusinesslayoutComponent,
  ],
  imports: [
    CommonModule,
    NgbDropdownModule,
    NgxPermissionsModule.forChild(),
    FeatherModule.pick(allIcons),
    SimplebarAngularModule,
    TranslateModule,
    RouterModule,
    ClickOutsideModule,
    SharedModule,
  ],
  providers: [LanguageService],
})
export class LayoutsModule {}
